import MenuModule from './MenuModule';

const MenuBloc = ({ open }) => {
    return <MenuModule open={open} />;
};

export default MenuBloc;
